import { getFeatureFlagOverride, setFeatureFlagOverride } from "@/utils/window";
import { FeatureFlag } from "@ternary/api-lib/constants/feature-flags";
import { useState } from "react";

export default function useLocalFeatureFlagOverrides() {
  const [overrides, setOverrides] = useState<
    Record<FeatureFlag, boolean | null>
  >(
    Object.values(FeatureFlag).reduce<Record<FeatureFlag, boolean | null>>(
      (acc, flag) => {
        acc[flag] = getFeatureFlagOverride(flag);
        return acc;
      },
      {} as Record<FeatureFlag, boolean | null>
    )
  );

  const setLocalFeatureFlagOverride = (
    flag: FeatureFlag,
    value: boolean | null
  ) => {
    setOverrides((prev) => ({ ...prev, [flag]: value }));
    setFeatureFlagOverride(flag, value);
  };

  return { localFeatureFlagOverrides: overrides, setLocalFeatureFlagOverride };
}
